module.exports = __webpack_public_path__ + "img/Impact characterisation-Routine.e72070f2.svg";